import { getUrl, isServedToChina } from "@/utils/domainResolver";

export { AuthenticatedHeaderIBApplicationComplete } from "./IBApplicationComplete";
export { AuthenticatedHeaderIBApplicationNotComplete } from "./IBApplicationNotComplete";
export { AuthenticatedHeaderOnlySignedUp } from "./OnlySignedUp";

export const LAUNCH_PERSONAL_TRADING_URL = isServedToChina()
  ? `${getUrl(import.meta.env.VITE_ALT_PEPPERSTONE_COM_BASE_URL)}`
  : `${getUrl(import.meta.env.VITE_PEPPERSTONE_COM_BASE_URL)}/api/auth/login`;
